module.exports = __webpack_public_path__ + "img/bg02.32bebde2.png";